const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const short = require("short-uuid")
const constant = require("@/Config/constants").default;
const CustomizeUtil = require("@/appUtils/CustomizeUtil");

class InspectMasterEditVM {

  constructor(tenantId) {
    this.tenantId = tenantId
    this.isNew = true
    this.customizeRecord = {}
  }
  async init(sk = null, isCopy = false) {
    // 新規フラグ更新
    this.isNew = sk == "" || sk == null || isCopy

    // order取得用
    const currentMaster = (await InspectMasterModel.getInspectMasterList(this.tenantId)).filter(function(item) {
      console.log(JSON.stringify(item, null, "\t"))
      return !item._deleted === true
    }).sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });
    let newOrder = 0
    if (currentMaster.length > 0) {
      newOrder = currentMaster.slice(-1)[0].inspectMaster.order + 1
    }

    // カスタマイズレコードを取得する
    this.customizeRecord = await CustomizeUtil.checkCustomizeRecords(this.tenantId)

    if (sk) {
      // DBから取得
      try {
        this.data = await InspectMasterModel.getInspectMaster(sk, this.tenantId)
        if (this.data._deleted == true) {
          this.data = null
          throw new Error('deleted')
        }

        if (isCopy) {
          // コピーデータを作成するため、skだけ新規採番する
          const tmp = await InspectMasterModel.getNewData()
          this.data.sk = tmp.sk
          // フォーム名にcopyを付与
          this.data.inspectMaster.name += `-Copy`
          // orderをセット
          this.data.inspectMaster.order = newOrder
          // ロックフラグはfalseに
          this.data.inspectMaster.lockFlg = false
          // idをクリア
          delete this.data.id
          this.data.inspectMaster.id = tmp.inspectMaster.id

          // アイコンのIDはユニークとなるように採番
          this.data.inspectMaster.iconSetting.forEach(function(icon){
            icon.id = short.generate()
          })

        }

        // ※アイコンクラスはアイコンIDとしておく
        // this.data.inspectMaster.iconSetting.forEach(function(icon){
        //   icon.iconClass = icon.id
        // })
      } catch (e) {
        console.log(`InspectMasterEditVM init error ${e}`)
        throw e
      }

    } else {
      // 新規レコード
      this.data = await InspectMasterModel.getNewData()
      // orderをセット
      this.data.inspectMaster.order = newOrder
      // アイコンを１つ追加
      await this.addIcon()
    }
  }
  async save() {
    try {
      if (this.isNew) {
        // 新規追加
        console.log(`add`)

        await InspectMasterModel.addInspectMaster(this.data)
      } else {
        // 更新
        console.log(`update`)
        await InspectMasterModel.updateInspectMaster(this.data)
      }
    } catch (e) {
      console.log(`InspectMasterEditVM save error:${JSON.stringify(e)}`)
      throw e
    }
  }
  /**
   * ステータスを追加する。idが指定されていればその位置にセットする。
   * @param {*} id
   */
  addIcon(id = null) {
    try {
      let iconSettingMaxLength = 10
      let iconFilePath = constant.iconpath.icon1

      // カスタマイズ機能判定
      let isCustomized = this.customizeRecord.key === CustomizeUtil.customizeSumigomu
      if (isCustomized) {
        iconSettingMaxLength = this.customizeRecord.maxItem
        iconFilePath = constant.sumigomuicon[0].key
      }

      if (this.data.inspectMaster.iconSetting.length >= iconSettingMaxLength) {
        throw {
          code: 1,
          error: "Reached the maximum number."
        }
      }
      let id = short.generate()
      let newItem = {
        id: id,
        name: "新規アイコン",
        iconFilePath: iconFilePath,
        order: this.data.inspectMaster.iconSetting.length,
        isDefault: this.data.inspectMaster.iconSetting.length == 0,
      }
      if (id) {
        this.insertIconTo(id, newItem)
      } else {
        this.data.inspectMaster.iconSetting.push(newItem)
      }
    } catch (e) {
      if (e.code) {
        throw e
      } else {
        throw {
          code: 99,
          error: `unknown error. ${JSON.stringify(e)}`
        }
      }

    }
  }

  /**
   * ステータスアイコンを削除する
   * @param {*} id
   */
  removeIcon(id) {
    // フィルターして新しい配列を作成する
    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.filter(function(item) {
      return item.id != id
    }.bind(this))
  }
  /**
   * ステータスアイコンをコピーする
   * @param {*} id
   */
  copyIcon(id) {
    let newItem = this.data.inspectMaster.iconSetting.filter(function(item) {
      return item.id == id
    }.bind(this))
    if (newItem) {
      if (newItem.length > 0) {
        this.insertTo(id, newItem)
      }
    }
  }
  /**
   * 初期値指定を変更。
   * @param {*} id
   */
  changeDefaultSelect(id) {
    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.map(function(item) {
      if (item.id != id) {
        item.isDefault = false
      } else {
        item.isDefault = true
      }
      return item
    })
  }
  /**
   *
   * @param {*} direction true:order値増 false:order値減
   * @param {*} id
   */
  changeOrder(pastValue, newValue, id) {
    console.log(`changeOrder ${pastValue} ${newValue} ${id}`)
    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.map(function(item) {
      if (item.order == newValue) {
        console.log(`other set id@${item.id} ${item.order} → ${pastValue}`)
        item.order = pastValue
      }
      return item
    })
    console.log(JSON.stringify(this.data.inspectMaster.iconSetting, null, "\t"))

    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.map(function(item) {
      if (item.id == id) {
        console.log(`own set id@${id} ${item.order} → ${newValue} ${id}`)
        item.order = newValue
      }
      return item
    })
    console.log(JSON.stringify(this.data.inspectMaster.iconSetting, null, "\t"))

    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;

    })
    console.log(JSON.stringify(this.data.inspectMaster.iconSetting, null, "\t"))
  }

  /**
   * ステータスアイコンを指定ID位置の後方にセットする
   * @param {*} id
   * @param {*} newItem
   */
  insertIconTo(id, newItem) {

    // 仮の並び順をセット
    newItem.order += 0.5
    this.data.inspectMaster.iconSetting.push(newItem)
    // orderで昇順に並び替える
    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    })
    // index値を用いてorderを整数値に書き換える
    this.data.inspectMaster.iconSetting = this.data.inspectMaster.iconSetting.map(function(item, index) {
      item.order = index
      return item
    })
  }

  /**
   * ステータスを追加する。idが指定されていればその位置にセットする。
   * @param {*} id
   */
  addInspectItem(id = null) {
    let newItem = {
      id: short.generate(),
      name: ``,
      itemType: "0",
      required: "false",
      order: this.data.inspectMaster.inspectItemList.length,
      defaultValue: "",
      systemDateFlg: false,
      items: []
    }
    if (id) {
      console.log(`addInspectItem id指定あり`)
      this.insertInspectItemTo(newItem, id)
    } else {
      console.log(`addInspectItem id指定なし`)
      this.data.inspectMaster.inspectItemList.push(newItem)
    }

    return newItem
  }
  /**
   * フォーム項目を削除する
   * @param {*} id
   */
  removeInspectItem(id) {
    // フィルターして新しい配列を作成する
    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.filter(function(item) {
      return item.id != id
    }.bind(this))
  }
  /**
   * フォーム項目をコピーする
   * @param {*} id
   */
  copyInspectItem(id) {
    console.log(`copyInspectItem ${id}`)
    let originalItem = this.data.inspectMaster.inspectItemList.filter(function(item) {
      return item.id == id
    }.bind(this))
    if (originalItem) {
      if (originalItem.length > 0) {
        // 複製
        let newItem = Object.assign({}, originalItem[0])
        newItem.id = short.generate(),
        newItem.name = `${newItem.name}-Copy`
        this.insertInspectItemTo(newItem, id)
      }
    }
  }
  /**
   * ステータスアイコンを指定ID位置の後方にセットする
   * @param {*} id
   * @param {*} newItem
   */
  insertInspectItemTo(newItem, id = null) {
    console.log(`insertInspectItemTo ${JSON.stringify(newItem)}`)
    console.log(`insertInspectItemTo ${this.data.inspectMaster.inspectItemList.length}件`)
    if (id) {
      const prevItem = this.data.inspectMaster.inspectItemList.filter(function(item) {
        return item.id == id
      }.bind(this))
      if (prevItem.length > 0) {
        newItem.order = prevItem.order + 0.5
      }
    } else {
      // 指定が無ければ最後にセット
      newItem.order = this.data.inspectMaster.inspectItemList.length
    }

    this.data.inspectMaster.inspectItemList.push(newItem)
    // orderで昇順に並び替える
    this.data.inspectMaster.inspectItemList.sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    })
    // index値を用いてorderを整数値に書き換える
    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.map(function(item, index) {
      item.order = index
      return item
    })
    console.log(`insertInspectItemTo ${this.data.inspectMaster.inspectItemList.length}件`)
  }
  /**
   *
   * @param {*} direction true:order値増 false:order値減
   * @param {*} id
   */
  inspectItemChangeOrder(pastValue, newValue, id) {
    console.log(`changeOrder ${pastValue} ${newValue} ${id}`)
    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.map(function(item) {
      if (item.order == newValue) {
        console.log(`other set id@${item.id} ${item.order} → ${pastValue}`)
        item.order = pastValue
      }
      return item
    })
    console.log(JSON.stringify(this.data.inspectMaster.inspectItemList, null, "\t"))

    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.map(function(item) {
      if (item.id == id) {
        console.log(`own set id@${id} ${item.order} → ${newValue} ${id}`)
        item.order = newValue
      }
      return item
    })
    console.log(JSON.stringify(this.data.inspectMaster.inspectItemList, null, "\t"))

    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;

    })
    console.log(JSON.stringify(this.data.inspectMaster.inspectItemList, null, "\t"))
  }
  /**
   * リスト選択アイテムを追加
   * @param {*} inspectItemId
   */
  addItems(inspectItemId) {
    let item = {
      id: short.generate(),
      name: "",
      isDefault: false,
      order: 0
    }
    this.data.inspectMaster.inspectItemList.forEach(function(inspectItem) {
      if (inspectItem.id == inspectItemId) {
        // 初期連番をセット
        item.order = inspectItem.items.length
        // 初期選択フラグをセット
        item.isDefault = inspectItem.items.length == 0
        // 追加
        inspectItem.items.push(item)
      }
    }.bind(this))
  }
  /**
   * リスト選択アイテムを並び替え
   * @param {*} inspectItemId
   * @param {*} pastValue
   * @param {*} newValue
   * @param {*} id
   */
  itemChangeOrder(inspectItemId, pastValue, newValue, id) {
    this.data.inspectMaster.inspectItemList.forEach(function(inspectItem) {
      if (inspectItem.id == inspectItemId) {
        inspectItem.items = inspectItem.items.map(function(item) {
          if (item.order == newValue) {
            item.order = pastValue
          }
          return item
        })

        inspectItem.items = inspectItem.items.map(function(item) {
          if (item.id == id) {
            item.order = newValue
          }
          return item
        })

        inspectItem.items = inspectItem.items.sort(function(a, b){
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        })
      }
    }.bind(this))
  }
  /**
   * 初期選択
   * @param {*} inspectItemId
   * @param {*} id
   */
  changeItemDefaultSelect(inspectItemId, id){
    const target = this.data.inspectMaster.inspectItemList.filter(function(item){
      return item.id == inspectItemId
    }.bind(this))
    target[0].items = target[0].items.map(function(item) {
      if (item.id != id) {
        item.isDefault = false
      } else {
        item.isDefault = true
      }
      return item
    })
  }
  /**
   * リスト選択アイテムから指定IDの要素を削除
   * @param {*} inspectItemId
   * @param {*} id
   */
  removeItem(inspectItemId, id) {
    this.data.inspectMaster.inspectItemList.forEach(function(inspectItem) {
      if (inspectItem.id == inspectItemId) {
        inspectItem.items = inspectItem.items.filter(function(item) {
          return item.id != id
        })
      }
    })
  }
  /**
   * 画面表示用のアイテムリスト
   */
  itemList() {

    let list = []
    list.push({
      class: 1,
      name: `${this.data.inspectMaster.statusName}`,
      inputType: this.data.inspectMaster.iconSelectType == "1" ? "4" : "5",
      id: "",
      order: -1
    })

    this.data.inspectMaster.inspectItemList.forEach(function(item){
      /**
       * id:String
        name:String
        itemType:String
        masterType:String
        required:Boolean
        order:Int
        defaultValue:String
       */
      list.push({
        class: 2,
        name: item.name,
        inputType: item.itemType,
        id: item.id,
        order: item.order
      })
      console.log(JSON.stringify(item, null, "\t"))
    }.bind(this))

    return list
  }
}
module.exports = InspectMasterEditVM;
